export default __webpack_public_path__ + "static/media/bamboo-icon.a59ba27e.svg";